import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "@zillow/constellation-10";
import { IconDollarSignCircleFilled, IconHouseFilled } from "@zillow/constellation-icons";
import { AFFORDABILITY_DTI_MAX } from "../AffordabilityCalculator.utils.esm.js";
const AFFORDABILITY_IMG_MIN = 40;
const AFFORDABILITY_IMG_MAX = 100;
const AFFORDABILITY_SIZE = AFFORDABILITY_IMG_MAX - AFFORDABILITY_IMG_MIN;
function getImageRatios({
  customPayment,
  monthlyPayment,
  maximumPayment,
  dti
}) {
  let ratio;
  if (customPayment) {
    ratio = monthlyPayment / maximumPayment;
  } else {
    ratio = dti / AFFORDABILITY_DTI_MAX;
  }
  const big = AFFORDABILITY_IMG_MIN + AFFORDABILITY_SIZE * ratio;
  const small = AFFORDABILITY_IMG_MAX - AFFORDABILITY_SIZE * ratio;
  return {
    big,
    small
  };
}
function AffordabilityGraphic({
  customPayment,
  monthlyPayment,
  maximumPayment,
  dti
}) {
  const imageRatios = getImageRatios({
    customPayment,
    monthlyPayment,
    maximumPayment,
    dti
  });
  return /* @__PURE__ */ jsxs(Box, { css: {
    minHeight: "100px",
    position: "relative",
    marginBottom: "5px"
  }, children: [
    /* @__PURE__ */ jsx(Box, { css: {
      position: "absolute",
      bottom: 0,
      left: "20px"
    }, style: {
      width: imageRatios.small,
      height: imageRatios.small
    }, children: /* @__PURE__ */ jsx(IconDollarSignCircleFilled, { width: imageRatios.small, height: imageRatios.small }) }),
    /* @__PURE__ */ jsx(Box, { css: {
      position: "absolute",
      bottom: 0,
      right: "20px"
    }, children: /* @__PURE__ */ jsx(IconHouseFilled, { width: imageRatios.big, height: imageRatios.big }) })
  ] });
}
export {
  AffordabilityGraphic as default
};
